import { convertDateStringToObject } from "../../../utils/helpers/human-readable-date-parser";

export const getDate = (publishedDate = "") => {
    if (!publishedDate) return "";
    const { day, month, year } = convertDateStringToObject(publishedDate);
    return `${day} ${month}, ${year}`;
};
